


@if (showAnimation) {
  <div style="overflow: hidden; max-height: 200px; position: absolute; z-index: 1; pointer-events: none; width: 100%">
    <lottie-anim #endAnim
				 (animCmpleted)="showAnimation = false"
				 [options]="{animation: 'sent', autoplay: true, loop: false, speed: 1.7 }" [height]="250" style="position: relative; top:-20px;" ></lottie-anim>
  </div>
}

<div class="px-3 py-2" >

  <div class="my-panel no-shadow _bg ">
    <div class="my-panel-body" style="font-size:0.9rem;">
      <div class="text-center mb-3" style="font-size: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem">
        <div class="mt-2 animated zoomIn"><img src="/assets/images/logo.svg" (mousedown)="runAnimation()"/></div>
        <div class="text-accent pre-wrap">{{ 'TO.end_success_title' | translate }}</div>
        @if ($storage.resultOrder?.number) {
          <div class="flex-center-middle">
            <span>{{ 'PO.ORDER_NO' | translate }}:</span>
            <b class=" text-accent">{{ $storage.resultOrder.number }}</b>
          </div>
        }
      </div>

      <!--<p>{{'TO.end-success-description'}}</p>-->

      <app-tabit-order-info [options]="{from:'end'}" style="font-size: 1.0em"></app-tabit-order-info>


      <div class="text-center" style="font-size: 1.0em">


		<div class="mt-3 d-inline-flex flex-direction gap-3 align-items-stretch justify-content-center" style="margin:0 auto; flex-direction: column; " >

			<button mat-flat-button color="accent" style="height: 50px" class="shadow-sm"  (click)="viewBill()">
				<div class="d-flex align-items-center gap-1">
					<mat-icon svgIcon="invoice"></mat-icon>
					{{ 'view_bill' | translate }}
				</div>
			</button>

			<div class="font-bold">{{'send_invoice_prompt' | translate}}</div>

			<div class="d-flex align-items-center gap-2">
				<button mat-stroked-button class="rounded" (click)="sendInvoice('email')">
					<div class="d-flex align-items-center gap-2 text-accent">
						<mat-icon svgIcon="envelope"></mat-icon>
						<span>{{ 'send_invoice_email' | translate }}</span>
					</div>
				</button>

				<button mat-stroked-button class="rounded" (click)="sendInvoice('sms')">
					<div class="d-flex align-items-center gap-2 text-accent">
						<mat-icon svgIcon="sms"></mat-icon>
						<span>{{ 'send_invoice_sms' | translate }}</span>
						<small>({{ userPhone | phone }})</small>
					</div>
				</button>
			</div>


      </div>
    </div>
  </div>

  <div class="members-group-container my-panel _bg no-shadow animated fadeInUp" [ngClass]="{'_collapsed': itemsCollapsed}">
    <div class="_group-container-header" style="background-color: #fafafa !important;"  (mousedown)="itemsCollapsed = !itemsCollapsed">
      <div class="title ">
        <span>{{ 'TD.items-summary' | translate }}</span>
      </div>
      <mat-icon class="collapsicon-caret">keyboard_arrow_up</mat-icon>
    </div>
    <div class="_group-container-body">
      <div class="items-summary-content" style="padding:0; min-height: 80px;" >
        @for (offer of $storage.basket; track offer; let last = $last) {
          <div class="basket-row" [class.last]="last">
            <div class="_header">
              @if (offer.quantity > 1) {
                <div class="_counter text-highlight">
                  {{offer.quantity}}*
                </div>
              }
              <div class="_title">
                {{offer.name}}
              </div>
              <div class="_price text-highlight">
                {{offer.quantity * offer.total | lcurrency}}
              </div>
            </div>
            <div class="_summary">
              @if (offer._item && offer._item.summary) {
                <div class="_summary-row"><div>{{offer._item.summary.text}}</div></div>
              }
              @if (offer.selectionSummary?.length) {
                @for (group of offer.selectionSummary | filterBy:{_visible:true}; track group) {
                  <div class="_summary-row">
                    <b>{{group.name}}:</b>
                    @for (item of group.items; track item) {
                      <div>
                        <div>
                          @if (item.count > 1) {
                            <span>{{item.count}}*</span>
                          }
                          {{item.name || 'missing'}}
                          @if (item._item.total > 0) {
                            <span class="inline m-near-xs">+{{item._item.total | lcurrency}}</span>
                          }
                        </div>
                        @if (item.$wasEdit && item._item.summary) {
                          <small class="block mb-1">{{item._item.summary.text}}</small>
                        }
                      </div>
                    }
                  </div>
                }
              }
              @if (offer.offerRemrks) {
                <div class="_summary-row">
                  <i>*{{offer.offerRemrks}}</i>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="fixed-bottom p-3">
  <button mat-flat-button color="primary" class="lg btn-block" type="button" (mousedown)="_restartOrder()">
    {{'TO.add_another_order' |translate}}
  </button>
</div>
